import { proxy } from 'valtio';

import type { Team } from 'models';

const state = proxy<{
    team: Team | null;
}>({
    team: null,
});

export { state };
